import { useState, useCallback } from 'react';
import { useMountedState } from 'react-use';

import { fetchAddresses } from 'APIPackage/KnmModule/services/knmAddressesApi';

export function useKnmAddresses() {
  const isMounted = useMountedState();
  const [isSuccess, setIsSuccess] = useState(false);
  const [addresses, setAddresses] = useState<Array<string>>([]);

  const getAddresses = useCallback(
    async (query: string) => {
      try {
        setIsSuccess(false);
        const response = await fetchAddresses({
          query,
        });

        if (isMounted()) {
          setAddresses(response);
          setIsSuccess(true);
        }
      } catch (err) {
        //
      }
    },
    [isMounted],
  );

  return {
    isSuccess,
    getAddresses,
    addresses,
  };
}
